import { render, staticRenderFns } from "./PDF.vue?vue&type=template&id=6ff51480&scoped=true&"
import script from "./PDF.vue?vue&type=script&lang=js&"
export * from "./PDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff51480",
  null
  
)

export default component.exports